import { Input } from 'reactstrap'

export default function YesNoSelect({name, handleChange, multiple, defaultValue}) {
  const options = []
  options.push(<option key={0} value={''}></option>)
  options.push(<option key={1} value={'Y'}>Yes</option>)
  options.push(<option key={2} value={'N'}>No</option>)

  return (
    <Input style={{width: 'auto', display: 'inline-block'}} type='select' name={name} multiple={multiple} className='yes-no-input' onChange={handleChange} defaultValue={defaultValue}>
      {options}
    </Input>
  )
}